import * as React from "react"
import { Link, graphql, navigate } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

import Layout from "../components/layout"
import SEO from "../components/seo"
// import Link from "../components/link"
import RecommendedPosts from "../components/Blog/RecommendedPosts"
import {ArrowDown} from "../components/icons/arrow-down-icon"

const ExternalLink = props => {
  if (
    props.href.includes("https://dannielhansel.com/") ||
    props.href[0] === "/"
  ) {
    return (
      <a
        {...props}
        href={props.href}
        className="font-semibold text-accent hover:underline hover:underline-offset-4 cursor-pointer"
      >
        {props.children}
      </a>
    )
  }
  return (
    <a
      {...props}
      href={props.href}
      className="font-semibold text-accent hover:underline hover:underline-offset-4 cursor-pointer"
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  )
}

const About = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const siteUrl = data.site.siteMetadata.canonicalUrl
  const { frontmatter, body } = data.bio.edges[0].node
  // const { postFrontmatter } = data.related.edges
  console.log(data.site.siteMetadata.canonicalUrl)
  return (
    <MDXProvider
      components={{
        p: props => (
          <p
            {...props}
            className="font-body2 tracking-normal lg:tracking-widest text-left text-main text-md md:text-xl font-normal md:font-medium px-4 mt-10 leading-relaxed md:leading-loose"
          />
        ),
        em: props => (
          <em
            {...props}
            className="text-2xl font-medium font-sans text-gray-500 italic"
          />
        ),
        a: ExternalLink,
        img: props => (
          <img 
            {...props}
            className="w-48 lg:w-64 float-left aspect-[1/1] rounded-lg shadow-lg object-cover object-center mb-0 mr-6 [clip-path:circle(70%_at_20%_30%)] [shape-outside:circle(70%_at_20%_30%)] lg:[clip-path:polygon(0%_0%,100%_0%,75%_100%,0%_100%)] lg:[shape-outside:polygon(0%_0%,100%_0%,75%_100%,0%_100%)]"
            alt={siteTitle}
          />
        )
      }}
    >
      <Layout location={location} title={siteTitle}>
        <SEO 
          title="About Danniel Hansel" 
          description="Learn more about me and how I got to where I am now." 
          keywords={["about", "danniel", "danniel hansel", "daniel", "danielhansel"]}
          url={`${siteUrl}${location.pathname}`} />
        <div className="overflow-x-hidden">
          <div className="container mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 place-items-center gap-4 h-screen">
              <div className="">
                <div className="block lg:hidden relative w-full max-w-lg">
                  <div className="absolute top-0 -left-4 w-64 h-64 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                  <div className="absolute top-0 -right-4 w-64 h-64 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                  <div className="absolute -bottom-8 left-20 w-64 h-64 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                  <div className="mx-auto rounded-full relative w-60 h-60">
                    <img src={frontmatter.profileUrl} className="object-cover md:object-scale-down h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent" alt={frontmatter.author} />
                  </div>
                </div>
                <header className="px-4">
                  <h1 className="font-body2 mt-20 lg:mt-0 font-medium text-3xl lg:text-5xl text-quarternary text-start">Hi, I'm <span className="text-accent">Danniel Hansel</span>, I'm a full stack engineer.
                  </h1>
                  <h2 className="font-medium text-3xl lg:text-5xl text-secondary-text text-start mt-6">
                    I design, code and build simply beautiful things, and I love what I do.
                  </h2>
                  <div 
                    className="hidden md:flex items-center justify-start text-secondary-text hover:text-quarternary pt-12"
                    // onClick={() => { navigate("/#about")}}
                    >
                      <Link to="#about-me" aria-label="read more about Danniel Hansel">
                        <button class="flex flex-cols-2 space-x-6 items-center justify-center">
                          <ArrowDown />
                          <span className="font-body1 relative text-2xl font-semibold leading-relaxed tracking-tight ">Learn more about Danniel</span>
                        </button>
                      </Link>
                      
                  </div>
                </header>
              </div>
              <div className="hidden lg:block ">
                <div className="relative w-full max-w-lg">
                    <div className="absolute top-0 -left-20 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob "></div>
                    <div className="absolute top-0 -right-4 w-96 h-96 bg-yellow-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                    <div className="absolute -bottom-8 left-20 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
                    <div className="mx-auto rounded-full relative w-80 h-80 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
                    <img src={frontmatter.profileUrl} className="object-cover h-full w-full rounded-full ring ring-accent ring-offset-4 ring-offset-transparent"alt={frontmatter.author} />
                  </div>
                  </div>
              </div>
            </div>
            <section id="about-me" className=" mx-auto scroll-mt-44 lg:scroll-mt-60">
              <article 
              itemScope
              itemType="http://schema.org/Article">
                <h3 className="font-body2 mt-20 lg:mt-0 font-medium text-3xl lg:text-5xl text-quarternary text-center">About Danniel Hansel</h3>
                <div className="mt-20">
                  <MDXRenderer>{body}</MDXRenderer>
                </div>

              </article>
              <div className="mt-48 lg:mt-64">
                <RecommendedPosts content={data.related.edges} />
              </div>
            </section>
          </div>
        </div>
    </Layout>

    </MDXProvider>
  )
}

export default About

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        canonicalUrl
        image
        author {
          name
        }
        organization {
          name
          url
          logo
        }
        social {
          twitter
        }
      }
    }
    bio: allMdx(filter: { fileAbsolutePath: { regex: "/content/about/" }, frontmatter: {category: {eq: "long-bio"}} }) {
      edges {
        node {
          body
          frontmatter {
            title
            caption
            description
            author
            profileUrl
            category
          }
        }
      }
    }
    related: allMdx(
      limit: 3
      filter: {
        fileAbsolutePath: { regex: "/content/blog/" }
        frontmatter: { published: { eq: true }, featured: { eq: true } }
      }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            slug
            title
            author
            bannerUrl
            bannerCredit
            slug
            tags
            description
            date(formatString: "Do MMM YYYY")
          }
          excerpt
          id
          body
          timeToRead
        }
      }
    }
  }
`